export const producerConstants = {
  PRODUCER_GET_ALL: "PRODUCER_GET_ALL",
  UPDATE_PRODUCER: "UPDATE_PRODUCER",
  GET_PRODUCER: "GET_PRODUCER",
  RESET_PRODUCER: 'RESET_PRODUCER'
  };
  